 <template>
  <v-dialog
    v-model="dialog"
    max-width="850"
    persistent
    class="overflow-y-hidden"
  >
    <v-card class="pt-2 pl-0 pr-0">
      <v-card-title
        class="headline-6 overflow-y-hidden"
        :class="{ 'subtitle-2': $vuetify.breakpoint.xs }"
        style="word-break: normal; !important"
      >
        {{ $vuetify.lang.t("$vuetify.DETALHES_DISPONIBILIDADE") }}
      </v-card-title>

      <v-col class="ml-8 mb-n10" cols="3" v-if="$hasProfile('Administrador')">
        <v-row>
          <span
            class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
          >
            {{ $vuetify.lang.t("$vuetify.SIGLA") }}:</span
          >
        </v-row>
        <v-row>
          <v-select
            :items="Array.from(desigMap.keys())"
            solo
            dense
            v-model="selectedAcronym"
            @change="filterDPN()"
          ></v-select>
        </v-row>
      </v-col>

      <v-list class="ma-0 pa-0 overflow-y-hidden mt-3" max-height="500">
        <v-row class="ma-0">
          <v-col class="col-2 ml-6 mt-n2">
            <LabelValue
              :label="$vuetify.lang.t('$vuetify.DPN_REDE')"
              :value="selectedAcronym ? Intl.NumberFormat('pt-BR').format(acronymPercentual) + '%' : '--'"
              justify="start"
              style="width: 150px"
              customStyle="100px"
              truncate
            ></LabelValue>
          </v-col>

          <v-col class="col-2 ml-6 mt-n2">
            <LabelValue
              :label="$vuetify.lang.t('$vuetify.CIRCUITOS_ATIVOS')"
              :value="selectedAcronym ? activeCircuitsCount : '--'"
              justify="start"
              style="width: 150px"
              customStyle="100px"
              truncate
            ></LabelValue>
          </v-col>

          <v-col class="col-3 ml-6 mt-n2">
            <LabelValue
              :label="$vuetify.lang.t('$vuetify.TOTAL_HORAS_PREVISTAS')"
              :value="
                selectedAcronym ? Intl.NumberFormat('pt-BR').format(totalForeseenHours) : '--'
              "
              justify="start"
              style="width: 150px"
              customStyle="100px"
              truncate
            ></LabelValue>
          </v-col>

          <v-col class="col-3 ml-6 mt-n2">
            <LabelValue
              :label="$vuetify.lang.t('$vuetify.TOTAL_HORAS_PERDIDAS')"
              :value="
                selectedAcronym ? Intl.NumberFormat('pt-BR').format(totalLostHours) : '--'
              "
              justify="start"
              style="width: 150px"
              customStyle="100px"
              truncate
            ></LabelValue>
          </v-col>
        </v-row>

        <span class="ml-7 text-caption primary--text font-weight-bold"
          >{{ $vuetify.lang.t("$vuetify.DISPONIBILIDADE_CIRCUITO") }}
        </span>

        <v-data-table
          :headers="headers"
          :items="formatData()"
          class="elevation-2 mt-2 mb-2 ml-7 mr-7 overflow-x-auto"
          fixed-header
          no-data-text="Sem informações"
          height="35vh"
          dense
        >
        </v-data-table>
      </v-list>

      <v-divider class="mt-5"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-2" text @click="close()">
          {{ $vuetify.lang.t("$vuetify.FECHAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LabelValue from "../../components/LabelValue";

export default {
  components: {
    LabelValue,
  },
  props: {
    close: Function,
    dialog: Boolean,
    historic: Object,
    date: String
  },
  methods: {
    filterDPN(){
      
      var circuits = this.historic.disponibilidadeCircuitos.filter(c =>
        c.circuito.nome.toLowerCase().includes(this.selectedAcronym.toLowerCase())
      );

      this.totalForeseenHours = circuits.length * 24 * 
                  this.getNumberOfDays(Number(this.date.split('/')[0]), Number(this.date.split('/')[1]));
      
      this.totalLostHours = circuits.reduce((sum, item) => sum + item.tempoReparoTotal, 0);
      this.activeCircuitsCount = circuits.length;

      this.acronymPercentual = (1 - this.totalLostHours / this.totalForeseenHours) * 100;

    },
    getNumberOfDays(month, year) {
      const usedYear = year ?? new Date().getFullYear(); 
      const monthIndex = month - 1; 

      const days = new Date(usedYear, monthIndex + 1, 0);
      return days.getDate();
    },
    getAcronym(desigTpz){
      return desigTpz.split("-")[0];
    },
    formatData() {
      if (
        !this.historic ||
        this.historic.disponibilidadeCircuitos.length == 0
      ) {
        return;
      }

      var disponibilidadeCircuitos = [];
      for (var index in this.historic.disponibilidadeCircuitos) {
        var object = Object.assign(
          {},
          this.historic.disponibilidadeCircuitos[index]
        );

        object.designacaoTpz = object.circuito.nome;
        object.tempoReparoTotal = Intl.NumberFormat("pt-BR").format(
          this.historic.disponibilidadeCircuitos[index].tempoReparoTotal
        );

        object.percentualDisponibilidade =
          object.percentualDisponibilidade.toFixed(2) + "%";

        disponibilidadeCircuitos.push(object);
      }

      return disponibilidadeCircuitos;
    },
  },
  data() {
    return {
      activeCircuitsCount: undefined,
      acronymPercentual: undefined,
      totalForeseenHours: undefined,
      totalLostHours: undefined,
      selectedAcronym: undefined,
      desigMap: undefined,
      loadingApproval: false,
      headers: [
        {
          text: this.$vuetify.lang.t('$vuetify.DESIGNACAO_TPZ'),
          align: "center",
          sortable: false,
          value: "designacaoTpz",
          width: "9rem",
        },
        {
          text: this.$vuetify.lang.t('$vuetify.TEMPO_TOTAL_REPARO'),
          align: "center",
          sortable: false,
          value: "tempoReparoTotal",
          width: "8rem",
        },
        {
          text: "%",
          align: "center",
          sortable: false,
          value: "percentualDisponibilidade",
          width: "8rem",
        },
      ],
    };
  },
  created: function () {
    this.headers.forEach((h) => (h.class = "black--text caption1"));
    this.desigMap = new Map(this.historic.disponibilidadeCircuitos.
                    map(obj => [this.getAcronym(obj.circuito.nome), obj]));

    if(Array.from(this.desigMap.keys()).length == 1){
      this.selectedAcronym = Array.from(this.desigMap.keys())[0];
      this.filterDPN();
    }
  },
};
</script>